import { t } from '../../../i18n.es.js';
import React, { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import { styled } from '@teko/ui';
import { PriceInput } from './PriceInput.es.js';
import { OrderBy } from '../../../types.es.js';
import { getTrackingData } from '@teko/tracking';
import { SelectOption } from '../../../Common/SelectOption/SelectOption.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const StyledOption = styled(SelectOption)((props) => `
  margin-right: 1rem;
  cursor: pointer;
  color: ${props.isActive ? props.theme.brand.primary : ""};
  background-color: ${props.isActive ? props.theme.brand.tertiary : ""};
  padding: 0.5rem;
  &:hover {
    background: ${props.isActive ? "" : "#f3f3f3"};
  }
`);
const OptionName = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
`;
const FilterPriceButton = styled.button((props) => `
  background: ${props.theme.brand.primary};
  border: none;
  color: #fff;
  padding: 0px 15px;
  border-radius: 4px;
  margin-left: 5px;
  visibility: visible;
  height: 2.1rem;
  line-height: 2.1rem;
  visibility: ${props.show ? "visible" : "hidden"};
`);
const Wrapper = styled.div`
  background: #fff;
  width: 100%;
  border-bottom: 1px solid #eaeaea;
  font-size: 14px;
  height: 64px;
  display: flex;
  justify-content: space-between;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
`;
const FlexCenter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 13px;
`;
const PriceRange = styled.div`
  height: 40px;
  line-height: 37px;
  padding: 0 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
`;
const Title = styled.div`
  margin-right: 2rem;
  font-weight: 600;
`;
const Flag = styled.div`
  position: absolute;
  top: -72px;
`;
const StyledPriceInput = styled(PriceInput)`
  width: 100px;
  margin: 0 10px;
`;
const stringToNumber = (str) => {
  const v = str.replace("/[^0-9]/g", "");
  return v ? parseInt(v) : 0;
};
const SortBar = ({
  className,
  onClickOption,
  onSortByPrice
}) => {
  const currentQuery = useRouter().query;
  const [priceGte, setPriceGte] = useState();
  const [priceLte, setPriceLte] = useState();
  useEffect(() => {
    var _a, _b;
    setPriceLte(stringToNumber(((_a = currentQuery.price_lte) == null ? void 0 : _a.toString()) || ""));
    setPriceGte(stringToNumber(((_b = currentQuery.price_gte) == null ? void 0 : _b.toString()) || ""));
  }, [currentQuery.price_lte, currentQuery.price_gte]);
  const onSearch = (gte, lte) => {
    if (gte && lte && gte > lte) {
      setPriceLte(gte);
      setPriceGte(lte);
      lte = [gte, gte = lte][0];
    }
    onSortByPrice && onSortByPrice(gte, lte);
  };
  useEffect(() => {
    var _a;
    if (typeof window !== "undefined" && currentQuery.page) {
      (_a = document.getElementById("js-sort-bar")) == null ? void 0 : _a.scrollIntoView();
    }
  }, [currentQuery.page]);
  return /* @__PURE__ */ React.createElement(Wrapper, {
    className
  }, /* @__PURE__ */ React.createElement(Flag, {
    id: "js-sort-bar"
  }), /* @__PURE__ */ React.createElement(FlexCenter, null, /* @__PURE__ */ React.createElement(Title, null, t("S\u1EAFp x\u1EBFp theo")), /* @__PURE__ */ React.createElement(StyledOption, __spreadValues({
    stickySize: "sm",
    isActive: currentQuery.sort === "SORT_BY_DISCOUNT_PERCENT",
    onClickOption: () => onClickOption && onClickOption("SORT_BY_DISCOUNT_PERCENT", OrderBy.DESC)
  }, getTrackingData({
    isTrackContent: true,
    regionName: "sortFilterProduct",
    contentName: "sort=discount&order=DESC",
    target: "searchProductResult",
    payload: JSON.stringify({
      screenName: "searchProductResult"
    })
  })), /* @__PURE__ */ React.createElement(OptionName, null, t("Khuy\u1EBFn m\xE3i t\u1ED1t nh\u1EA5t"))), /* @__PURE__ */ React.createElement(StyledOption, __spreadValues({
    stickySize: "sm",
    activeBackground: "rgba(20, 53, 195, 0.08)",
    isActive: currentQuery.sort === "SORT_BY_TOP_SALE_QUANTITY_90_DAYS",
    onClickOption: () => onClickOption && onClickOption("SORT_BY_TOP_SALE_QUANTITY_90_DAYS", OrderBy.DESC)
  }, getTrackingData({
    isTrackContent: true,
    regionName: "sortFilterProduct",
    contentName: "sort=quantity.last_3_month&order=DESC",
    target: "searchProductResult",
    payload: JSON.stringify({
      screenName: "searchProductResult"
    })
  })), /* @__PURE__ */ React.createElement(OptionName, null, t("B\xE1n ch\u1EA1y"))), /* @__PURE__ */ React.createElement(StyledOption, __spreadValues({
    stickySize: "sm",
    activeBackground: "rgba(20, 53, 195, 0.08)",
    isActive: currentQuery.sort === "SORT_BY_PUBLISH_AT",
    onClickOption: () => onClickOption && onClickOption("SORT_BY_PUBLISH_AT", OrderBy.DESC)
  }, getTrackingData({
    isTrackContent: true,
    regionName: "sortFilterProduct",
    contentName: "sort=new&order=DESC",
    target: "searchProductResult",
    payload: JSON.stringify({
      screenName: "searchProductResult"
    })
  })), /* @__PURE__ */ React.createElement(OptionName, null, t("M\u1EDBi v\u1EC1"))), /* @__PURE__ */ React.createElement(StyledOption, __spreadValues({
    stickySize: "sm",
    activeBackground: "rgba(20, 53, 195, 0.08)",
    isActive: currentQuery.sort === "SORT_BY_PRICE" && currentQuery.order === OrderBy.DESC,
    onClickOption: () => onClickOption && onClickOption("SORT_BY_PRICE", OrderBy.DESC)
  }, getTrackingData({
    isTrackContent: true,
    regionName: "sortFilterProduct",
    contentName: "sort=bestPrice&order=DESC",
    target: "searchProductResult",
    payload: JSON.stringify({
      screenName: "searchProductResult"
    })
  })), /* @__PURE__ */ React.createElement(OptionName, null, t("Gi\xE1 gi\u1EA3m d\u1EA7n"))), /* @__PURE__ */ React.createElement(StyledOption, __spreadValues({
    stickySize: "sm",
    activeBackground: "rgba(20, 53, 195, 0.08)",
    isActive: currentQuery.sort === "SORT_BY_PRICE" && currentQuery.order === OrderBy.ASC,
    onClickOption: () => onClickOption && onClickOption("SORT_BY_PRICE", OrderBy.ASC)
  }, getTrackingData({
    isTrackContent: true,
    regionName: "sortFilterProduct",
    contentName: "sort=bestPrice&order=ASC",
    target: "searchProductResult",
    payload: JSON.stringify({
      screenName: "searchProductResult"
    })
  })), /* @__PURE__ */ React.createElement(OptionName, null, t("Gi\xE1 t\u0103ng d\u1EA7n"))), onSortByPrice && /* @__PURE__ */ React.createElement(PriceRange, null, /* @__PURE__ */ React.createElement(StyledPriceInput, {
    value: priceGte || "",
    placeholder: t("Gi\xE1 th\u1EA5p nh\u1EA5t"),
    onChange: setPriceGte,
    onEnter: (value) => onSearch(value, priceLte)
  }), "-", /* @__PURE__ */ React.createElement(StyledPriceInput, {
    value: priceLte || "",
    placeholder: t("Gi\xE1 cao nh\u1EA5t"),
    onChange: setPriceLte,
    onEnter: (value) => onSearch(priceGte, value)
  }), /* @__PURE__ */ React.createElement(FilterPriceButton, __spreadValues({
    show: !!priceLte || !!priceGte,
    onClick: () => onSearch(priceGte, priceLte)
  }, getTrackingData({
    isTrackContent: true,
    regionName: "sortFilterProduct",
    contentName: "applyFilter",
    target: "searchProductResult",
    payload: JSON.stringify(__spreadValues(__spreadValues({
      screenName: "searchProductResult"
    }, priceLte ? { priceLte } : {}), priceGte ? { priceGte } : {}))
  })), t("T\xECm")))));
};

export { SortBar };
